// extracted by mini-css-extract-plugin
export default {"root":"InvestmentCompanyDetailView_root__zUAn3","updatesPanel":"InvestmentCompanyDetailView_updatesPanel__dTiXx"};